<template>
  <button
    @click="emitClick()"
    class="StandardBorderedButton"
    :class="[
      color,
      { disabled: disabled },
      { fluid: fluid },
      { 'desktop-fluidity': desktopFluidity },
      {
        forward: forwardIcon,
        down: downChevron,
      },
    ]"
  >
    <div class="lds-ellipsis" v-if="locked">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <template v-else>
      <p>{{ title }}</p>
      <Arrow v-if="forwardIcon" />
      <Chevron2 color="white" v-if="downChevron" />
    </template>
  </button>
</template>

<script>
import Arrow from '@/assets/icons/Arrow'
import Chevron2 from '@/assets/icons/Chevron2'
export default {
  name: 'StandardSolidButton',
  props: [
    'title',
    'disabled',
    'fluid',
    'desktopFluidity',
    'forwardIcon',
    'downChevron',
    'backwardsIcon',
    'color',
    'locked',
  ],
  components: {
    Arrow,
    Chevron2,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    emitClick() {
      if (!this.locked && !this.disabled) {
        this.$emit('click')
      }
    },
  },
  mounted() {},
  beforeCreate() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
.StandardBorderedButton {
  user-select: none;
  background-color: $twilight;
  border: 1px solid $twilight;
  color: white;
  height: 48px;
  transition: 0.3s;
  letter-spacing: 0.16px;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;

  p {
    margin: 0;
    font-size: 16px;
    @include Gilroy-Bold;
  }

  &.forward,
  &.down {
    svg {
      margin-left: 9px;
    }
  }

  &.fluid {
    width: auto;
    padding: 0 20px;
  }

  &.disabled {
    background-color: $sleet;
    border-color: $sleet;
    color: $sleet;
    cursor: default;

    &:hover {
      background-color: $sleet;
      border-color: $sleet;
      color: $sleet;
    }
  }

  &:hover {
    border-color: $twilightshade;
    background-color: $twilightshade;
  }

  &.midnight {
    background-color: $midnight;
    border: 1px solid $midnight;
    color: white;

    &:hover {
      background-color: black;
      border: 1px solid black;
    }
  }

  &.grass {
    background-color: $grass;
    border: 1px solid $grass;
    color: white;

    &:hover {
      background-color: $grassshade;
      border: 1px solid $grassshade;
    }
  }
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 6px;
}

.lds-ellipsis div {
  position: absolute;
  top: 0px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 4px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 4px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 16px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 28px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(12px, 0);
  }
}

.midnight {
  background-color: $midnight;
  border: 1px solid $midnight;
  color: white;

  &:hover {
    background: black;
    border: 1px solid black;
  }
}

.mist {
  background-color: $mist;
  border: 1px solid $mist;
  color: $midnight;

  &:hover {
    background: $fog;
    border: 1px solid $fog;
  }
}

.cloud {
  background-color: $cloud;
  border: 1px solid $cloud;
  color: $midnight;

  &:hover {
    background: $fog;
    border: 1px solid $cloud;
  }
}

.fog {
  background-color: $fog;
  border: 1px solid $fog;
  color: $midnight;

  &:hover {
    background: $sleet;
    border: 1px solid $fog;
  }
}

.sunrise {
  background-color: $sunrise;
  border: 1px solid $sunrise;

  &.disabled {
    border-color: $sleet;
    color: $sleet;
    cursor: default;
  }

  &:hover {
    border-color: $sunrise;
    background-color: $sunrise;
  }
}

@media (min-width: 1200px) {
  .StandardBorderedButton {
    &.desktop-fluidity {
      width: auto;
    }
  }
}
</style>
